import axios from 'axios'
import cookie from '~/utils/cookie'
import Vue from 'vue'
import {aseDecrypt} from './crypto'
import { baseURL, baseURL2 } from '../config/index'

const bar = Vue.prototype.$bar

// 30秒中断请求
axios.defaults.timeout = 30000

// 拦截发送请求
axios.interceptors.request.use(
  config => {
    let token = cookie.get('T_j_cms_token')
    token && (config.headers.Authorization = 'Bearer ' + token)
    bar.start()
    return config
  },
  err => {
    bar.finish()
    return Promise.reject(err)
  }
)

// 拦截返回结果
axios.interceptors.response.use(
  res => {
    if (res.status === 200) {
      let token
      if (res.headers && res.headers.authorization) {
        token = res.headers.authorization.substr(7)
        cookie.set('T_j_cms_token', token)
      }
      if (res.data.code === 0) {
        // TODO
        res.data.data = typeof res.data.data === 'string' ? aseDecrypt(res.data.data) : res.data.data
      }
      if (res.data.code === 10127 || res.data.code === 10126 || res.data.code === 10117) {
        // token失效
        cookie.remove('T_j_cms_token')
        localStorage.removeItem('userInfo')
        location.href = '/login'
      }
    }
    bar.finish()
    return res
  },
  err => {
    bar.finish()
    return Promise.reject(err)
  }
)

/**
 * request封装
 */
function fetchData (method, url, data = {}, source = '') {
  let base = ''
  switch (source) {
    case 'java':
      base = baseURL2
      break
    default:
      base = baseURL
      break
  }

  return new Promise((resolve, reject) => {
    let request
    if (method === 'get' || method === 'delete') {
      request = axios[method](base + url, { params: data })
    } else {
      request = axios[method](base + url, data)
    }
    request
      .then(res => {
        resolve(res)
      })
      .catch(e => {
        reject(e)
      })
  })
}

export function get (url, params, domain = '') {
  return fetchData('get', url, params, domain)
}

export function post (url, data, domain = '') {
  return fetchData('post', url, data, domain)
}

export function put (url, data, domain = '') {
  return fetchData('put', url, data, domain)
}

export function remove (url, params, domain = '') {
  return fetchData('delete', url, params, domain)
}

export function upload (url, data, domain = '') {
  const formData = new FormData()
  Object.keys(data).forEach((child) => {
    formData.append(child, data[child])
  })
  return post(url, formData, domain)
}



// WEBPACK FOOTER //
// ./src/api/config.js